import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-buy-success',
  templateUrl: './buy-success.component.html',
  styleUrls: ['./buy-success.component.scss']
})
export class BuySuccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
